import { render, staticRenderFns } from "./cuota-personalizada-page.vue?vue&type=template&id=23ab9036&scoped=true&"
import script from "./cuota-personalizada-page.vue?vue&type=script&lang=js&"
export * from "./cuota-personalizada-page.vue?vue&type=script&lang=js&"
import style0 from "./cuota-personalizada-page.vue?vue&type=style&index=0&id=23ab9036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ab9036",
  null
  
)

export default component.exports